import { render, staticRenderFns } from "./ScrollList.vue?vue&type=template&id=7a2a475e&"
import script from "./ScrollList.vue?vue&type=script&lang=ts&"
export * from "./ScrollList.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports